<template>
  <div class="delivery">
    <v-radio-group v-if="!natalLuz" v-model="delivery">

      <div
        @click="selectDelivery(option)"
        v-for="option in deliveryOptions"
        :key="option.codigo"
        class="delivery-option"
        :class="delivery == option.codigo ? 'option-active' : 'option-deactive'"
      >
        <component class="delivery-option__svg" v-bind:is="option.icon"></component>

        <div class="delivery-option__info">
          <v-layout class="pb-2" row>
            <label :for="option.codigo">{{ option.nome }}</label>
          </v-layout>
          <h5 class="checkout-h5" v-html="option.descricao.replaceAll('\n\n', '<br/> <br/>') || option.descricao_checkout"></h5>
        </div>
        <v-radio color="primary" :id="option.codigo" :value="option.codigo"></v-radio>
      </div>
    </v-radio-group>
    <span v-else>Ao realizar esta compra estou de acordo sobre a minha responsabilidade em informar a organização do Natal Luz sobre casos positivos para Covid-19 detectados em até 10 dias após a presença no espetáculo das pessoas para quem estou realizando a compra de ingressos.</span>
    <v-checkbox v-if="natalLuz" class="mt-3" label="Li e estou de acordo" v-model="terms"></v-checkbox>
    <next-step :enabled="natalLuz ? terms : delivery" />
  </div>
</template>

<script>
import EticketIcon from '../UI/icon/EticketIcon';
import EticketPrintedIcon from '../UI/icon/EticketPrintedIcon';
import CheckinIcon from '../UI/icon/CheckinIcon';
import RetiradaIcon from '../UI/icon/RetiradaIcon';
import NextStep from '../UI/NextStepButton';

export default {
  components: {
    EticketIcon,
    EticketPrintedIcon,
    CheckinIcon,
    RetiradaIcon,
    NextStep,
  },
  props: ['deliveryOptions'],
  data() {
    return {
      delivery: 0,
      terms: false
    };
  },
  computed: {
    deliveryOption: {
      get() {
        return this.$store.getters.deliveryOption;
      },
      set(value) {
        this.delivery = value;
        this.$store.dispatch('setDeliveryOption', value);
      },
    },
    eventName() {
      return this.$store.getters.eventName
    },
    natalLuz () {
      if (this.eventName && this.eventName.includes('Natal Luz')) {
        return true
      } else return false
    }
  },
  mounted() {
    if (this.deliveryOptions && this.deliveryOptions.length === 1) {
      this.delivery = this.deliveryOptions[0].codigo
      this.$store.dispatch('setDeliveryOptionObject', this.deliveryOptions[0]);
      this.$store.dispatch('setDeliveryOption', this.deliveryOptions[0].codigo);
    }
  },
  methods: {
    selectDelivery (option) {
      this.$store.dispatch('setDeliveryOptionObject', option)
      this.deliveryOption = option.codigo
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/delivery/deliveryOptions.styl';
</style>
